module.exports = __webpack_public_path__ + "static/media/ic_miscellenous.e21d64f8.svg";